import React from 'react';
import CmsRichText from '../common/CmsRichText';

export default function HomeIntroduction({ content }) {
  const sections = Array.isArray(content?.sections) ? content.sections : [];
  const text = sections.filter(s => ['article', 'text'].includes(s.type));
  if (!text.length) return null;
  return <section aria-label="Om platformen og booking" className="home-introduction">
    {text.map((section, index) => { const data = section.data || section;
      return <div key={section.id || index}>
        {(data.heading || data.title) && <h2>{data.heading || data.title}</h2>}
        <CmsRichText content={data.content || data.description} />
      </div>;
    })}
  </section>;
}
